import React, { useState, useRef, useEffect } from "react";
import PageWrapper from "./components/PageWrapper";
import { useFormCtx } from "./FormContext";

import * as Const from "./_Const";

import Navbar from "./components/Navbar";
import Button from "./components/Button";

function PageErrorLog() {
  const { logText, sendLogToApi } = useFormCtx();
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.scrollTop = textareaRef.current.scrollHeight;
    }
  }, [logText]);

  return (
    <>
      <Navbar useCustomTitle={true} customTitle={"Log web aplikace"} />
      <div className="mt-4 flex flex-col space-y-4 mx-6">
        <textarea
          className="bg-disabled text-sm w-full h-[320px] scRPIV2:text-base scRPIV2:h-[490px] scWaveShare:text-base scWaveShare:h-[580px] tvHD:text-base tvFullHD:h-[820px] tvFullHD:text-2xl tv4K:h-[1640px] tv4K:text-5xl"
          ref={textareaRef}
          value={logText}
          readOnly
        />
        <div className="flex justify-center">
          <Button
            type="primary"
            title="Odeslat LOG do API"
            showIcon={false}
            onClick={() => sendLogToApi()}
            className="h-14 -mt-1 text-xs scRPIV2:h-20 scRPIV2:text-base scWaveShare:h-20 scWaveShare:text-base tvHD:h-20 tvHD:text-base tvFullHD:h-30 tvFullHD:text-2xl tv4K:h-44 tv4K:text-5xl tv4K:mt-4"
          />
        </div>
      </div>
    </>
  );
}

export default PageErrorLog;
